import { Sync, SyncProblem } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';
import SituacaoAlteracaoMinuta from '@/dominio/SituacaoAlteracaoMinuta';
import SituacaoAlteracaoMinutaBusiness from '@/dominio/SituacaoAlteracaoMinutaBusiness';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';

class StatusMinuta extends ReactComponent {
    modalConfirmacaoOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            modalConfirmacaoOpen: observable,
            registro: computed,
            statusMinuta: computed,
            cor: computed,
            tooltip: computed,
            getStatusMinuta: computed,
            onClickStatusMinuta: action,
            verificarAlteracoes: action,
            callbackConfirmar: action,
            callbackCancelar: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get statusMinuta() {
        return this.registro && this.getStatusMinuta;
    }

    get cor() {
        if (this.observableProps.id) {
            return SituacaoAlteracaoMinuta.getCor(this.observableProps.id);
        }

        if (this.statusMinuta && this.statusMinuta.cor) {
            return this.statusMinuta.cor;
        }

        return 'black';
    }

    get tooltip() {
        if (this.observableProps.id) {
            return SituacaoAlteracaoMinuta.getDescricao(this.observableProps.id);
        }

        if (this.statusMinuta) {
            return this.statusMinuta.onClickEnabled
                ? this.statusMinuta.texto + ' - Marcar a(s) alteração(ões) como analisadas?'
                : this.statusMinuta.texto;
        }

        return undefined;
    }

    get getStatusMinuta() {
        let statusMinuta = SituacaoAlteracaoMinutaBusiness.getStatusMinuta(this.registro);

        if (this.observableProps.apenasIcone) {
            if (statusMinuta) {
                statusMinuta.onClickEnabled = false;
            }
        }

        if (statusMinuta) {
            if (statusMinuta.onClickEnabled) {
                statusMinuta.cursor = 'pointer';
            } else {
                statusMinuta.cursor = 'default';
            }
        }

        return statusMinuta;
    }

    onClickStatusMinuta() {
        return this.statusMinuta.onClickEnabled && this.verificarAlteracoes();
    }

    verificarAlteracoes() {
        this.modalConfirmacaoOpen = true;
    }

    callbackConfirmar = async () => {
        this.modalConfirmacaoOpen = false;
        await this.sessaoService.registrarAnaliseMinuta(this.registro.sessaoId, this.registro.processo.numeroCompleto);
        await this.salaSessaoStore.recarregarProcesso(this.registro);
        await this.sessaoService.ordenarProcessos(this.registro.sessaoId);
        this.mensagemStore.abrirMensagemSucesso('Alterações marcadas como analisadas pela Secretaria.');
    };

    callbackCancelar = () => {
        this.modalConfirmacaoOpen = false;
    };

    renderModalStatusMinuta() {
        return (
            <ModalConfirmacao
                open={this.modalConfirmacaoOpen}
                callbackConfirmar={this.callbackConfirmar}
                callbackCancelar={this.callbackCancelar}
                titulo={'Alterações na minuta'}
            >
                <Typography>Confirma que as alterações foram analisadas?</Typography>
            </ModalConfirmacao>
        );
    }

    render() {
        const analisado = this.observableProps.analisado || (this.statusMinuta && this.statusMinuta.analisado);
        const opacidade = 0.8;

        if (this.observableProps.apenasIcone) {
            if (analisado) {
                return (
                    <Tooltip title={this.tooltip}>
                        <Sync style={{ fill: this.cor, fillOpacity: opacidade }} />
                    </Tooltip>
                );
            }

            return (
                <Tooltip title={this.tooltip}>
                    <SyncProblem style={{ fill: this.cor, fillOpacity: opacidade }} />
                </Tooltip>
            );
        }

        if (this.statusMinuta) {
            if (analisado) {
                return (
                    <>
                        <Tooltip title={this.tooltip}>
                            <Box
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor:
                                        this.statusMinuta && this.statusMinuta.cursor ? this.statusMinuta.cursor : ''
                                }}
                                onClick={this.onClickStatusMinuta.bind(this)}
                            >
                                <Sync style={{ fill: this.cor, fillOpacity: opacidade }} />
                            </Box>
                        </Tooltip>
                        {this.renderModalStatusMinuta()}
                    </>
                );
            }

            return (
                <>
                    <Tooltip title={<Typography>{this.tooltip}</Typography>}>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: this.statusMinuta && this.statusMinuta.cursor ? this.statusMinuta.cursor : ''
                            }}
                            onClick={this.onClickStatusMinuta.bind(this)}
                        >
                            <SyncProblem style={{ fill: this.cor, fillOpacity: opacidade }} />
                        </Box>
                    </Tooltip>
                    {this.renderModalStatusMinuta()}
                </>
            );
        }

        return null;
    }
}

export default inject('stores')(observer(StatusMinuta));
